import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import { parseJwt } from "@lib/browser-utils";
import { useAiCurriculumUIStore } from "@src/stores/zustand/ai-curriculum-ui.store";
import { useOutcomesUIStore } from "@src/stores/zustand/outcomes-ui.store";

/**
 * Login flow types
 */
export const LOGIN_TYPES = {
  NORMAL: "normal",
  SSO: "sso",
  IMPERSONATE: "impersonate",
};

export const handleAuthError = (error, caches = {}) => {
  console.error(error);
  const { tokenCache, currentUserCache, appSettingsCache } = caches;

  tokenCache?.remove();
  currentUserCache?.remove();
  appSettingsCache?.remove();
};

export const createSessionId = (
  userId,
  exp,
  cookieName = "socket_identity",
  cookieConfig
) => {
  const sessionId = uuidv4();
  const cookieValue = `${userId}:${sessionId}`;

  Cookies.set(cookieName, cookieValue, {
    expires: new Date(exp * 1000),
    path: "/",
    secure: true,
    ...cookieConfig,
  });

  return sessionId;
};

export const finishLoginFlow = (user, caches, options = {}) => {
  const { type = LOGIN_TYPES.NORMAL, impersonatorId = null } = options;

  // These persist to sessionStorage, which outlives a logout within a tab, so
  // clear them on login too — one identity's data must never reach the next.
  useOutcomesUIStore.getState().clearStore();
  useAiCurriculumUIStore.getState().clearStore();

  const currentToken = parseJwt(user.token);
  caches.tokenCache.set(user.token, { exp: currentToken.exp });

  const sessionId = createSessionId(user.userId, currentToken.exp);

  let currentUser = {
    exp: currentToken.exp,
    sessionId,
    ...user,
  };

  if (type === LOGIN_TYPES.SSO) {
    currentUser.isSso = true;
  } else if (type === LOGIN_TYPES.IMPERSONATE) {
    currentUser.impersonatorId = impersonatorId || currentToken.impersonatorId;
    currentUser.impersonation = true;
  } else {
    currentUser.isSso = false;
  }

  caches.currentUserCache.set(currentUser, { exp: currentToken.exp });

  return currentUser;
};
